import { CSSObject } from '@emotion/react';
import { TDot, TDotContainer } from './Carousel.styles';

export const Dot = ({ selected }: TDot): CSSObject => ({
  bg: selected ? 'blackAlpha.800' : 'blackAlpha.300',
});

export const DotContainer = ({
  numberOfSlides,
  index,
}: TDotContainer): CSSObject => ({
  bgGradient: 'linear(to-b, #ADF106, #8FC608)',
  borderLeftRadius: index === 0 ? 'base' : '0',
  pl: index === 0 ? '0.5' : '0',
  borderRightRadius: index === numberOfSlides - 1 ? 'base' : '0',
  pr: index === numberOfSlides - 1 ? '0.5' : '0',
});

export const CarouselWrapper: CSSObject = {
  boxShadow: '0px 3px 4px 0px rgba(0, 0, 0, 0.2)',
  mb: '3',
};
